import type { RouteObject } from "react-router-dom";

export const goldenDomeRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Golden Dome" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { GoldenDomeDashboard } = await import(
            "./golden-dome-dashboard"
          );
          return { Component: GoldenDomeDashboard };
        },
      },
      {
        path: "notifications",
        handle: { breadcrumb: "Notifications" },
        async lazy() {
          const { GoldenDomeNotifications } = await import(
            "./golden-dome-notifications"
          );
          return { Component: GoldenDomeNotifications };
        },
      },
      {
        path: "app/:appIdentifier",
        handle: { breadcrumb: "App Details" },
        async lazy() {
          const { GoldenDomeAppDetails } = await import(
            "./golden-dome-app-details"
          );
          return { Component: GoldenDomeAppDetails };
        },
      },
    ],
  },
];
